"use strict";
/// <reference path="irep.js"/>

IREP.news = (function () {
    var options = null; //Holds the defined options that are passed via json.
    var wysiwygEditor = null; //The comment editor
    var wysiwygEditorLoading = false; //If the comment editor is currently loading, this prevents a second load.
    var headlineScroller = null; //The headline scroller reference.
    var currentCommentIndex = 1; //What the current top comment is that is displayed.
    var defaultSearchValue; //When searching, if nothing is selected, this restores the text value on the textbox/

    /*
    * Initialize news page items.
    */
    var init = function (newsOptions) {
        $("#dvMainContent").width($("#dvArticleTitle").width());
        options = newsOptions;

        alwaysInit();

        $("#newsFeedWindow").on('pjax:start', function () { $("#LoadingOverlay").fadeIn(); });
        $("#newsFeedWindow").on("pjax:timeout", function () { return false; });

        /* When a pjax call finishes, hide the loader and then reset the footer position; Sometimes we only get one or two items 
           back, so it doesn't fit a full screen. Other times, it needs to expand the screen size. */
        $("#newsFeedWindow").on('pjax:end', function () {
            $("#LoadingOverlay").fadeOut();
            IREP.master.setFooterPosition();
            alwaysInit();
        });

        initDateBrowser();

        initEditControls();
    };

    var initEditControls = function () {
        $('.blogeditcontents').click(function (e) {
            e.preventDefault();
            if ($("#overlay").length === 0) {
                $("body").append($("<div id='overlay' />").addClass("overlay"));

                $("#overlay").click(function () {
                    $('.blogeditcontentspopup').hide();
                    $('#overlay').remove();
                });
            }

            $('.blogeditcontentspopup').fadeIn(300);
        });
    };

    /*
    * A series of items that need to be re-initialized on pjax end and on initial config.
    */
    var alwaysInit = function () {
        initFilterControl(); //Configure the filter control functionality

        $("#btnAddComment").click(addComment);

        initRepeaterLinks();

        if (location.href.indexOf('page') != -1 && location.href.indexOf('article') != -1) {
            location.hash = "#dvCommentViewer";
        }
    }

    /*
    * When you click a headline, phase out the existing and phase in the item, using pjax. 
    */
    var initRepeaterLinks = function () {
        $(".loadArticleLink").click(function () {
            var selectedVal = $(this).attr("data-articleid");
            IREP.track(window.location.pathname, "ViewArticle", selectedVal, '', '');
            var href = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            href += "?";
            href += "article=" + selectedVal;

            $("#reloadLink").attr("href", href);
            $("#reloadLink").click();

            /* Jeff and Charlie had nothing to do with this */
            setTimeout(function () {
                $("#newsLinkContactUs").click(function () {
                    $("#aContactUs").click();
                });
            }, 5000);
            

        });
    }

    /*
    * Display the Wysiwyg controller allowing the user to post a news article comment.
    */
    var addComment = function () {
        if (wysiwygEditor === null && wysiwygEditorLoading === false) {
            wysiwygEditorLoading = true;
            $.get(IREP.options.appUrl + IREP.options.user.site.toLowerCase() + "/replyeditor.ajax", {}, function (html) {
                wysiwygEditor = IREP.wysiwyg.init({
                    container: $("<div>").addClass("replyContainer").append(html).appendTo("body"),
                    wysiwygId: "messageContent",
                    saveFunction: saveComment,
                    additionalPadding: 150,
                    failureText: options.failureText,
                    successText: options.successText
                });
            }).done(function () {
                wysiwygEditorLoading = false;
                $("#WysiwygImageEffects").hide();
                $("#WysiwygListEffects").hide();
            });
        } else {
            wysiwygEditor.show();
        }
        return false;
    };

    /*
     * Checks if the content has actual text. 
     */
    var isNotEmpty = function (value) {
        return $.trim($('<div>').html(value).text()) != "";
    }

    /*
     * Pull values from the window location. 
     */
    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    /*
    * Save the comment to the system via ajax.
    */
    var saveComment = function (successFunction, failFunction) {
        var comment = $("#messageContent").val();
        if (isNotEmpty(comment)) {
            var currentArticleId = getParameterByName('article');
            var postData = {
                ArticleId: currentArticleId,
                Comment: comment,
                isBlogComment: window.location.href.indexOf('blog') != -1,
                isNewsComment: window.location.href.indexOf('news') != -1
            };
            IREP.callApi("news/addComment", "POST", postData)
                .done(function (data) {
                    updateComments();
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    failFunction();
                });;
        } else {
            failFunction();
        }
        return false;
    };

    /*
    * After adding a comment, reload the page.
    */
    var updateComments = function () {
        window.location.reload();
    };

    /*
    * Initialize the filter control values and hint text display.
    */
    var initFilterControl = function () {
        var filterCtrl = $(".textFilterTitles");
        if (filterCtrl !== undefined && filterCtrl !== null) {
            defaultSearchValue = filterCtrl.attr("defaultText");

            // swap the deafult Search box text on blur and focus
            if (filterCtrl.val() === "") filterCtrl.val(defaultSearchValue);

            filterCtrl.focus(function () {
                if ($(this).val() === defaultSearchValue) {
                    $(this).val("");
                }
            })
             .blur(function () {
                 if ($(this).val() === "") {
                     $(this).val(defaultSearchValue);
                 }
             });
        }

        // Enter keypress should trigger the loadresults
        $(document).keypress(function (e) {
            if (e.which == 13) {
                execSearchFn();
                return false;
            }
        });

        //Search button on-click event
        $("#btnHeadlineSearch").click(function () {
            execSearchFn();
            return false;
        });

        $("#reloadLink").click(function () {
            if (!history.pushState) {
                window.location.href = this.href;
                return false;
            }
        });
    }


    /*
    * The search button functionality
    */
    var execSearchFn = function () {
        var filterCtrl = $(".textFilterTitles");
        var selectedVal = $("[ID*=hdnSelectedMonth]").val();
        var href = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
        href += "?";
        href += "month=" + selectedVal;
        if (filterCtrl.val() !== undefined && filterCtrl.val() !== null && filterCtrl.val() !== "" && filterCtrl.val() !== defaultSearchValue) {
            href += "&";
            href += "query=" + filterCtrl.val();
        }

        $("#reloadLink").attr("href", href);
        $("#reloadLink").click();
    }

    /*
    * Initialize the comment scroller when on a news article page
    */
    var initCommentScroller = function () {
        if ($("#dvScroller").length !== 0) {
            if ($(".dvCommentHolder").length === 0) {
                $("#spnCommentsHeader").text(options.NoCommentsString);
                $("#prevSet").hide();
                $("#nextSet").hide();
                $("#dvNotif").hide();
            }

            headlineScroller = IREP.DivScroller.init({
                windowPane: "dvScroller",
                innerPane: "dvScrollerInside",
                divHolder: "dvCommentHolder",
                prevBtn: "prevSet",
                nextBtn: "nextSet",
                indexDisplay: "dvNotif",
                displayCount: 5,
                textTemplate: options.ScrollerTemplateString
            });

            //This prevents the footer from not taking the new page size into account, with the expanded comments section. 
            $("#pageContent").height($("#dvNewsArticleDetails").height() + $("#dvScroller").height() + $("#breadcrumbs").height() + $("#pageHeaderContainer").height());
        }
    }

    /*
    * Initialize the date browser/filter for the news page.
    */
    var initDateBrowser = function () {
        $(".liDateBrowser").click(function () {
            $(".liDateBrowserSelected").animate({ width: "170px" }, 300);
            $(".liDateBrowserSelected").attr("class", "liDateBrowser"); //Remove class from whatever's selected
            $(".dvRecentPostsSelected").attr("class", "dvRecentPosts");

            $(this).attr("class", "liDateBrowserSelected"); //Set the selected flag
            $(this).animate({ width: "180px" }, 300);

            $("[ID*=hdnSelectedMonth]").val($(this).attr("data-monthid"));
            execSearchFn();
        });

        $("#divRecentPosts").click(function () {
            $(".liDateBrowserSelected").animate({ width: "170px" }, 300);
            $(".liDateBrowserSelected").attr("class", "liDateBrowser"); //Remove class from whatever's selected
            $("#divRecentPosts").attr("class", "dvRecentPostsSelected");
            $("[ID*=hdnSelectedMonth]").val("0");
            execSearchFn();
        });

    }

    return {
        init: init
    };
})();